import { render, staticRenderFns } from "./addFactureComponent.vue?vue&type=template&id=de3fd51a&"
import script from "./addFactureComponent.vue?vue&type=script&lang=js&"
export * from "./addFactureComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports